module.exports = __webpack_public_path__ + "img/log.9a0225cf.png";